const NAME = "GRID_PROCESS_RESULT_DIALOG";

export default NAME;
